const Loader = () => (
  <div className="loader-wrapper">
    <img width="120px" height="120px" src="/img/flightpath/gif/loader.gif" alt="loader" />
  </div>
);

export default Loader;
